import { Button, Stack } from '@mui/material'
import SubmitLockButton from 'components/submit-lock-button/submit-lock-button.component'

interface IProps {
  handleSendInvoice: () => void
  handleClose: () => void
}

const InvoiceEmailButtons = ({ handleSendInvoice, handleClose }: IProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      p={2}
      spacing={2}
      sx={{ borderTop: '1px solid #D9D9D9' }}
    >
      <Button
        variant="contained"
        sx={{
          borderRadius: '6px',
          textTransform: 'capitalize',
          fontWeight: 700,
          bgcolor: 'secondary.main',
          minWidth: '150px',
        }}
        onClick={handleClose}
      >
        Cancel
      </Button>

      <SubmitLockButton
        variant="contained"
        sx={{
          borderRadius: '6px',
          textTransform: 'capitalize',
          fontWeight: 700,
          bgcolor: 'primary.main',
          minWidth: '150px',
        }}
        onClick={handleSendInvoice}
      >
        Send Invoice
      </SubmitLockButton>
    </Stack>
  )
}

export default InvoiceEmailButtons
